import React, { useEffect, useState } from 'react';

const VisitorCounter = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const storedCount = localStorage.getItem('visitorCount') || 0;
    const newCount = parseInt(storedCount, 10) + 1;
    setCount(newCount);
    localStorage.setItem('visitorCount', newCount);
  }, []);

  return <div>Visitors: {count}</div>;
};

export default VisitorCounter;
